import { Button, Grid, Tab, Tabs, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { ITableCommonToolbar, TableCommon } from '../../../shared/components/TableCommon';
import { TableLoading } from '../../../shared/components/TableLoading';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { HomeContext } from '../../Home/HomeContext';
import { AuthContext } from '../../Authentication/AuthContext';
import { HistoryLocation } from '../enum/HistoryLocation';
import { PageLocation } from '../../../shared/enum/PageLocation';
import { NewsStatus } from '../enum/NewsStatus';
import InfluencerSpreadsheetService from '../../../Services/InfluencerService';
import { InfluencerSpreadsheetModel, InfluencerSpreadsheetModelInitial } from '../../../Models/InfluencerSpreadSheetModel';
import { AxiosError, AxiosResponse } from 'axios';
import { getTableColumn } from '../../../shared/operators';
import { Action, Column, Options } from 'material-table';
import { TableEmpty } from '../../../shared/components/TableEmpty';
import { NewsOrigin } from '../../../shared/enum/NewsOrigin';
import { theme } from '../../../theme';
export interface IHistoryClassificationProps {
    handlePageLocation: (location: PageLocation) => void;
}

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(1.5, 4),
        width: '100%',
        maxWidth: '1800px'
    },
    title: {
        margin: '20px 0px 32px'
    },
    tabs: {
        justifyContent: 'space-between',
        display: 'flex'
    },
    addNewButtonGrid: {
        justifyItems: 'center'
    },
    emptyTable: {
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        maxWidth: '1800px',
        padding: theme.spacing(0, 4)
    },
}));
export function InfluencerHistoryClassification() {
    const classes = useStyles();

    const authContext = React.useContext(AuthContext);
    const homeContext = React.useContext(HomeContext);

    const [historyType, setHistoryType] = React.useState<HistoryLocation>(HistoryLocation.PENDING);
    const [spreadsheets, setSpreadsheets] = React.useState<InfluencerSpreadsheetModel[]>([]);
    const [showConfirmDelete, setShowConfirmDelete] = React.useState(false);
    const [spreadsheetDelete, setSpreadsheetDelete] = React.useState<InfluencerSpreadsheetModel>(InfluencerSpreadsheetModelInitial);
    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        setLoading(true);

        if (historyType == HistoryLocation.PENDING) {
            InfluencerSpreadsheetService.getAllByStatusInfluencer(authContext.login.user.id, NewsStatus.PENDING)
                .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        }
        else if (historyType == HistoryLocation.CLASSIFIED) {
            InfluencerSpreadsheetService.getClassifiedSpreadsheetInfluencer(authContext.login.user.id)
                .then((res: AxiosResponse) => { setSpreadsheetsData(res.data); })
                .catch((error: AxiosError) => { homeContext.showError('', error); });
        } else
            setLoading(false);

    }, [historyType]);

    const setSpreadsheetsData = (data: InfluencerSpreadsheetModel[]) => {
        setSpreadsheets(data);
        setLoading(false);
    };

    const tableColumns: Column<InfluencerSpreadsheetModel>[] = [
        getTableColumn('Origem do Influenciador', 'fileDescription', 'string', 'left', undefined, undefined, false, false),
        getTableColumn('Responsável', 'nome', 'string', 'left', undefined, undefined, false),
        // getTableColumn('Clipadora', 'clipperDescription', 'string', 'left', undefined, undefined, false),
        {
            title: 'Data de inserção',
            field: 'creationDate',
            type: 'datetime',
            align: 'center',
            filtering: false,
            dateSetting: { locale: 'pt-BR' },
            defaultSort: 'desc',
            cellStyle: { minWidth: '190px' }
        }
    ];

    const pendingTableColumns: Column<InfluencerSpreadsheetModel>[] = [
        {
            title: 'Pendentes',
            render: (rowData: InfluencerSpreadsheetModel) => `${rowData.totalInfluencer - rowData.classificado} de ${rowData.totalInfluencer}`,
            type: 'string',
            align: 'center',
            filtering: false,
            customSort: (a: InfluencerSpreadsheetModel, b: InfluencerSpreadsheetModel) => a.classificado - b.classificado,
            cellStyle: { minWidth: '200px' }
        }
    ];

    const classifiedTableOptions: Options<InfluencerSpreadsheetModel> = {
        filtering: true,
        toolbar: true,
        showTitle: false,
        pageSizeOptions: [5, 10],
    };

    const pendingTableOptions: Options<InfluencerSpreadsheetModel> = {
        filtering: true,
        actionsColumnIndex: -1,
        pageSizeOptions: [5, 10],
    };

    const pendingTableToolbarText: ITableCommonToolbar = {
        title: '',
        subtitle: ''
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const pendingTableActions: (Action<any> | ((rowData: any) => Action<any>))[] = [
        {
            icon: 'edit',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Classificar',
            onClick: (_, rowData: InfluencerSpreadsheetModel) => {
                homeContext.setSpreadsheetId(rowData.id);
                homeContext.setPageLocation(PageLocation.CLASSIFICATION_INFLUENCER);
            }
        },
        rowData => ({
            icon: 'delete_outline',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Excluir inflcuenciador em lote',
            onClick: (_, rowData: InfluencerSpreadsheetModel) => {
                setSpreadsheetDelete(rowData);
                setShowConfirmDelete(true);
            },
            disabled: rowData.newsByStatus != rowData.totalInfluencer,
            hidden: rowData.newsByStatus != rowData.totalInfluencer
        }),
        // rowData => ({
        //     icon: 'list_alt_outlined',
        //     iconProps: { style: { fontSize: '20px' } },
        //     tooltip: 'Ver IDs gerados',
        //     onClick: (_, rowData: InfluencerSpreadsheetModel) => {
        //         homeContext.setSpreadsheetId(rowData.id);
        //         homeContext.setPageLocation(PageLocation.INFLUENCER_UPLOAD);
        //     },
        //     disabled: rowData.newsByStatus == rowData.totalInfluencer && rowData.totalInfluencer != 0,
        //     hidden: rowData.newsByStatus == rowData.totalInfluencer && rowData.totalInfluencer != 0
        // })
    ];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const classifiedTableActions: Action<any>[] = [
        {
            icon: 'list_alt_outlined',
            iconProps: { style: { fontSize: '20px' } },
            tooltip: 'Ver IDs gerados',
            onClick: (_, rowData: InfluencerSpreadsheetModel) => {
                homeContext.setSpreadsheetId(rowData.id);
                homeContext.setPageLocation(PageLocation.INFLUENCER_UPLOAD);
            }
        }
    ];

    const deleteSpreadsheet = () => {
        setShowConfirmDelete(false);
        InfluencerSpreadsheetService.InfluencerSpreadsheetService(authContext.login.user.id)
            .remove(spreadsheetDelete.id)
            .then(() => { window.location.reload(); });
    };

    const getTabs = () => {
        return (
            <Tabs
                classes={{ flexContainer: classes.tabs }}
                value={historyType}
                indicatorColor="primary"
                textColor="primary"
                onChange={(_, newValue: HistoryLocation) => setHistoryType(newValue)}>
                <Tab value={HistoryLocation.PENDING} label='Pendentes' />
                {/* <Tab value={HistoryLocation.CLASSIFIED} label='Classificados' /> */}
            </Tabs>
        );
    };

    const getTitleAndSubtitle = () => {
        return (
            <>
                <Typography variant="h4" className={classes.title}>
                    Histórico de Influenciadores
                </Typography>
                {getTabs()}
            </>);
    };

    const getAddNewButton = () => {
        return (
            <Grid item className={classes.addNewButtonGrid}>
                <Button
                    onClick={() => homeContext.setPageLocation(PageLocation.INFLUENCER_UPLOAD)}
                    size='large'
                    variant='contained'
                    color='primary'>
                    INSERIR NOVA PLANILHA
                </Button>
            </Grid>
        );
    };

    const getEmptyTable = (historyLocation: HistoryLocation, displayText: string) => {
        if (historyType == historyLocation && spreadsheets.length == 0 && !loading) {
            return (
                <Grid
                    container
                    spacing={3}
                    direction="column"
                    alignItems="center">
                    <Grid item className={classes.emptyTable}>
                        <TableEmpty displayText={displayText} />
                    </Grid>

                    {getAddNewButton()}
                </Grid>
            );
        }
    };


    return (
        <>
            <Grid container justify="center">
                <Grid
                    container
                    className={classes.root}
                    justify="flex-start"
                    direction="column">
                    {getTitleAndSubtitle()}

                    {spreadsheets.length > 0 && !loading && (
                        <TableCommon
                            tableData={spreadsheets}
                            tableColumns={tableColumns.concat(pendingTableColumns)}
                            emptyDataSourceMessage='Nenhum influenciador encontrado para esse filtro.'
                            tableActions={pendingTableActions}
                            extraOptions={pendingTableOptions}
                            toolbar={pendingTableToolbarText}
                            addNewButtonText='Inserir nova planilha'
                            addNewButtonPageLocation={PageLocation.INFLUENCER_UPLOAD}
                            style={{ padding: theme.spacing(0, 11) }} />
                    )}
                    {historyType == HistoryLocation.CLASSIFIED && spreadsheets.length > 0 && !loading && (
                        <TableCommon
                            tableData={spreadsheets}
                            tableColumns={tableColumns}
                            emptyDataSourceMessage='Nenhum influenciador encontrado para esse filtro.'
                            tableActions={classifiedTableActions}
                            extraOptions={classifiedTableOptions}
                            style={{ padding: theme.spacing(0, 11) }} />
                    )}

                    {loading &&
                        <TableLoading displayText="Carregando histórico " />}

                    {getEmptyTable(HistoryLocation.PENDING, 'Não existem dados pendentes')}
                    {getEmptyTable(HistoryLocation.CLASSIFIED, 'Não existem dados classificados')}
                </Grid>
            </Grid>
            <BasicConfirmDialog
                title={'Tem certeza que deseja excluir?'}
                description={
                    spreadsheetDelete && spreadsheetDelete.newsOrigin == NewsOrigin.SpreadsheetImport
                        ? 'Ao excluir esta planilha, você não poderá classificar os dados que ela contém.'
                        : 'Ao excluir este lote de Influenciador,' +
                        'não será possível obtê-lo novamente de maneira automática.'}
                handleFirstButton={deleteSpreadsheet}
                handleSecondButton={() => setShowConfirmDelete(false)}
                textFirstButton={'Excluir'}
                textSecondButton={'Cancelar'}
                open={showConfirmDelete} />
        </>
    );
}